export function getSubscriptionStatusString(value) {
    switch (value) {
        default:
        case 1:
            return "Unknown";
        case 2:
            return "Active";
        case 3:
            return "Deactivated";
        case 4:
            return "Grace Period";
        case 5:
            return "Canceled";
        case 6:
            return "Pending";
        case 7: 
            return "Active Pending Change"
    }
}

const subscriptionStatuses = {
    Unknown: 1,
    Active: 2,
    Deactivated: 3,
    GracePeriod: 4,
    Canceled: 5,
    Pending: 6,
    ActivePendingChange: 7
}

export { subscriptionStatuses };